import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { Location } from '~commonInfra/utils/Location';
import { Tableau } from '~commonInfra/utils/TableauLog';
import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { toggleBackgroundJobExtendedInfoDialog } from '../actions/ToggleBackgroundJobExtendedInfoDialog';
import { IBackgroundJobInfo } from '../types/BackgroundJobs';
import { buildTaskDetailsUrl } from '../utils/BackgroundJobUrls';

export class BackgroundJobExtendedInfoDialogCell extends React.Component<IBackgroundJobInfo> {

  private readonly toggleDialog = () => {
    if (this.props.taskLuid && FeatureFlags.backgroundJobsContentAndTaskDetailsEnabled) {
      const urls = siteUrlsSelector(getAppStore().getState());
      if (urls) {
        Location.instance.setUrl(buildTaskDetailsUrl(urls.jobsUrl(), this.props.taskLuid, this.props.jobId));
        return;
      }
      Tableau.Logger().warn('[BackgroundJobExtendedInfoDialogCell] siteUrlsSelector returned null, falling back to dialog');
    }
    getAppStore().dispatch(toggleBackgroundJobExtendedInfoDialog(this.props));
  };

  render() {
    /* eslint-disable jsx-a11y/interactive-supports-focus */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/anchor-is-valid */
    return <>
      <a data-tb-test-id="data-grid-cell-text" onClick={this.toggleDialog} role="button">
        {this.props.jobId + ''}
      </a>
    </>;
  }
}
